import React from 'react';
import { Button, Popover } from 'antd';

const SettingChip = ({ icon, label, active, compact, ariaLabel, title, content }) => (
	<Popover
		trigger="click"
		placement="bottomRight"
		title={title}
		content={content}
		destroyTooltipOnHide
	>
		{compact ? (
			<Button
				type="text"
				size="small"
				icon={icon}
				aria-label={ariaLabel}
				className="ChecklistEditor-ghost"
			/>
		) : (
			<Button
				size="small"
				shape="round"
				icon={icon}
				aria-label={ariaLabel}
				className={`ChecklistEditor-chip${active ? ' is-set' : ''}`}
			>
				{label}
			</Button>
		)}
	</Popover>
);

export default SettingChip;
